export default "__VITE_ASSET__DIGIS7jz__"